import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { tryToFetchAdminStats } from '../../../../store/brokers/partners/admin/adminSlice';
// import Discrepancies from '../admin-tabs/Discrepancies';
import Files from '../admin-tabs/Files';
import Rules from '../admin-tabs/Rules';
import Logs from '../admin-tabs/Logs';
import DetailedTab from './DetailedTab';

const tabs: any = [
    // { key: 'discrepancies', label: 'Discrepancies', icon: '/assets/admin-tab/admin-discrepancies.svg', iconWhite: '/assets/admin-tab/admin-discrepancies-white.svg', element: <Discrepancies /> },
    { key: 'files', label: 'Files and Templates', icon: '/assets/admin-tab/admin-files.svg', iconWhite: '/assets/admin-tab/admin-files-white.svg', element: <Files /> },
    { key: 'rules', label: 'Rules Editor', icon: '/assets/admin-tab/admin-rules.svg', iconWhite: '/assets/admin-tab/admin-rules-white.svg', element: <Rules /> },
    { key: 'logs', label: 'Logs', icon: '/assets/admin-tab/admin-logs.svg', iconWhite: '/assets/admin-tab/admin-logs-white.svg', element: <Logs /> },
];

const AdminTab = ({
	setActiveTabMain
}: {
	setActiveTabMain?: any
}) => {
    const dispatch = useAppDispatch();
    const [activeTab, setActiveTab] = useState<any>(tabs?.[0]);
    const statsData = useAppSelector((state) => state?.admin?.adminStats)

    useEffect(() => {
        dispatch(tryToFetchAdminStats())
    }, [])

    const formatNumber = (value: number | string | null | undefined): any => {
        if (value === null || value === undefined || value === '') return 0;

        const num = typeof value === 'string' ? parseFloat(value) : value;
        if (isNaN(num)) return '';

        return num.toLocaleString('en-US');
    };

	const handleShowStatus = (status: string) => {
		setActiveTabMain({ name: 'Detailed View', element: <DetailedTab status={status} /> })
	} 

    return (
        <div>
            <div className='grid grid-cols-1 lg:grid-cols-4 gap-4'>
                <div className='cols-span-1 lg:col-span-1 h-full flex flex-col'>
                    <div className='flex-1 rounded-xl p-4 mb-3 border border-1 border-[#6366F1]'>
                        <p className='mb-2 dark:text-primary-dark'>Total Records</p>
                        <p className='font-bold dark:text-primary-dark text-xl'>{formatNumber(statsData?.totalRecords)}</p>
                    </div>
                    <div className='flex-1 rounded-xl p-4 mb-3 border border-1 border-[#6366F1]'>
                        <p className='mb-2 dark:text-primary-dark'>Last Run</p>
                        <p className='font-bold dark:text-primary-dark text-xl'>{statsData?.lastRun?.time}</p>
                        {/* <p className='dark:text-primary-dark'>{statsData?.lastRun?.date}</p> */}
						<p className='dark:text-primary-dark'>Sep 11 2025</p> 
						
                    </div>
                    <div className='flex-1 rounded-xl p-4 border border-1 border-[#6366F1]'>
                        <p className='mb-2 dark:text-primary-dark'>Discrepancies</p>
                        <p className='font-bold dark:text-primary-dark text-xl'>{formatNumber(statsData?.discrepancies)}</p>
                        <p className='dark:text-primary-dark'>Require Attention</p>
                    </div>
                </div>
                <div className='cols-span-1 lg:col-span-3 rounded-xl p-4 h-full border border-1 border-[#6366F1]'>
                    <p className='font-bold mb-3 dark:text-primary-dark'>Match Rate</p>
                    <div className='grid grid-cols-2 gap-4 dark:text-primary-dark'>
                        <div className='border border-1 border-[#10B981] rounded-lg px-2 py-2 mb-2 dark:bg-black' onClick={()=>handleShowStatus('green')}>
                            <div className=''>
                                <div className='flex flex-row justify-between mb-2'>
                                    <img src='/assets/insights-tab/matched-icon.svg' className='object-contain h-[30px]' />
                                    <p className='text-[#10B981]'>{(statsData?.matchRate?.reconciled?.percentage || 0).toFixed(2)}%</p>
                                </div>
                                <div className='px-3'>
                                    <div className='grid grid-cols-3'>
                                        <p className='text-[#10B981] text-sm'>Total:</p>
                                        <p><span className='text-md text-[#10B981] mr-1'>{statsData?.matchRate?.reconciled?.count}</span>/ {statsData?.matchRate?.reconciled?.total}</p>
                                        <p className='text-sm font-bold text-[#10B981] text-right'>€{formatNumber(statsData?.matchRate?.reconciled?.amount || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>POS:</p>
                                        <p className='text-sm'>{statsData?.matchRate?.reconciled?.pos?.count}</p>
                                        <p className='text-sm  text-right'>€{formatNumber(statsData?.matchRate?.reconciled?.pos?.amount || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>PSP:</p>
                                        <p className='text-sm'>{statsData?.matchRate?.reconciled?.psp?.count}</p>
                                        <p className='text-sm text-right'>€{formatNumber(statsData?.matchRate?.reconciled?.psp?.amount || 0)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='border border-1 border-[#F59E0B] rounded-lg px-2 py-2 mb-2 dark:bg-black' onClick={()=>handleShowStatus('amber')}>
                            <div className='flex flex-row justify-between mb-2'>
                                <img src='/assets/insights-tab/likely-matched-icon.svg' className='object-contain h-[30px]' />
                                <p className='text-[#F59E0B]'>{(statsData?.matchRate?.potentialMatch?.percentage || 0).toFixed(2)}%</p>
                            </div>
                            <div className='px-3'>
                                <div className='grid grid-cols-3'>
                                    <p className='text-[#F59E0B] text-sm'>Total:</p>
                                    <p><span className='text-md text-[#F59E0B] mr-1'>{statsData?.matchRate?.potentialMatch?.count}</span>/ {statsData?.matchRate?.potentialMatch?.total}</p>
                                    <p className='text-sm font-bold text-[#F59E0B] text-right'>€{formatNumber(statsData?.matchRate?.potentialMatch?.amount || 0)}</p>
                                </div>
                                <div className='grid grid-cols-3 my-1'>
                                    <p className='text-sm'>POS:</p>
                                    <p className='text-sm'>{statsData?.matchRate?.potentialMatch?.pos?.count}</p>
                                    <p className='text-sm  text-right'>€{formatNumber(statsData?.matchRate?.potentialMatch?.pos?.amount || 0)}</p>
                                </div>
                                <div className='grid grid-cols-3 my-1'>
                                    <p className='text-sm'>PSP:</p>
                                    <p className='text-sm'>{statsData?.matchRate?.potentialMatch?.psp?.count}</p>
                                    <p className='text-sm text-right'>€{formatNumber(statsData?.matchRate?.potentialMatch?.psp?.amount || 0)}</p>
                                </div>
                            </div>
                        </div>

                        <div className='border border-1 border-[#EF4444] rounded-lg px-2 py-2 mb-2 dark:bg-black' onClick={()=>handleShowStatus('red')}>
                            <div className='flex flex-row justify-between mb-2'>
                                <img src='/assets/insights-tab/discrepancy-icon.svg' className='object-contain h-[30px]' />
                                <p className='text-[#EF4444]'>{(statsData?.matchRate?.unreconciled?.percentage || 0).toFixed(2)}%</p>
                            </div>
                            <div className='px-3'>
                                <div className='grid grid-cols-3'>
                                    <p className='text-[#EF4444] text-sm'>Total:</p>
                                    <p><span className='text-md text-[#EF4444] mr-1'>{statsData?.matchRate?.unreconciled?.count}</span>/ {statsData?.matchRate?.unreconciled?.total}</p>
                                    <p className='text-sm font-bold text-[#EF4444] text-right'>€{formatNumber(statsData?.matchRate?.unreconciled?.amount || 0)}</p>
                                </div>
                                <div className='grid grid-cols-3 my-1'>
                                    <p className='text-sm'>POS:</p>
                                    <p className='text-sm'>{statsData?.matchRate?.unreconciled?.pos?.count}</p>
                                    <p className='text-sm  text-right'>€{formatNumber(statsData?.matchRate?.unreconciled?.pos?.amount || 0)}</p>
                                </div>
                                <div className='grid grid-cols-3 my-1'>
                                    <p className='text-sm'>PSP:</p>
                                    <p className='text-sm'>{statsData?.matchRate?.unreconciled?.psp?.count}</p>
                                    <p className='text-sm text-right'>€{formatNumber(statsData?.matchRate?.unreconciled?.psp?.amount || 0)}</p>
                                </div>
                            </div>
                        </div>

                        <div className='border border-1 border-[#545863] rounded-lg px-2 py-2 mb-2 dark:bg-black' onClick={()=>handleShowStatus('voided')}>
                            <div className='flex flex-row justify-between mb-2'>
                                <img src='/assets/insights-tab/voided-icon.svg' className='object-contain h-[30px]' />
                                <p className='text-[#545863]'>{(statsData?.matchRate?.voidedTransaction?.percentage || 0).toFixed(2)}%</p>
                            </div>
                            <div className='px-3'>
                                <div className='grid grid-cols-3'>
                                    <p className='text-[#545863] text-sm'>Total:</p>
                                    <p><span className='text-md text-[#545863] mr-1'>{statsData?.matchRate?.voidedTransaction?.count}</span>/ {statsData?.matchRate?.voidedTransaction?.total}</p>
                                    <p className='text-sm font-bold text-[#545863] text-right'>€{formatNumber(statsData?.matchRate?.voidedTransaction?.amount || 0)}</p>
                                </div>
                                <div className='grid grid-cols-3 my-1'>
                                    <p className='text-sm'>POS:</p>
                                    <p className='text-sm'>{statsData?.matchRate?.voidedTransaction?.pos?.count}</p>
                                    <p className='text-sm  text-right'>€{formatNumber(statsData?.matchRate?.voidedTransaction?.pos?.amount || 0)}</p>
                                </div>
                                <div className='grid grid-cols-3 my-1'>
                                    <p className='text-sm'>PSP:</p>
                                    <p className='text-sm'>{statsData?.matchRate?.voidedTransaction?.psp?.count}</p>
                                    <p className='text-sm text-right'>€{formatNumber(statsData?.matchRate?.voidedTransaction?.psp?.amount || 0)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="w-full overflow-x-auto my-10">
                <div className="flex flex-col md:flex-row gap-2 bg-gray-100 dark:bg-black rounded-lg md:rounded-full p-1 min-w-full md:min-w-[400px] sm:min-w-0 justify-between">
                    {tabs.map((tab: any) => (
                        <button
                            key={tab.key}
                            onClick={() => setActiveTab(tab)}
                            className={`flex items-center justify-center gap-2 px-6 min-w-[16%] text-center py-2 rounded-lg md:rounded-full font-medium transition-all whitespace-nowrap ${activeTab?.key === tab.key
                                ? 'bg-[#1E3A8A] dark:bg-bgColor-darkMode text-white'
                                : 'text-gray-700  dark:text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-900'
                                }`}
                        >
                            <img src={activeTab?.key === tab?.key ? tab?.iconWhite : tab?.icon} className='object-contain mr-2 w-[22px]' />
                            <span className="text-sm">{tab?.label}</span>
                        </button>
                    ))}
                </div>
                {activeTab?.element}
            </div>
        </div >
    )
}
export default AdminTab;